import DeviceManager from '../utils/device-manager';
import Swiper from 'swiper';

type SinglePostListCarouselType = {
    $swipers: NodeListOf<HTMLElement>|null,
    swipers: { [key: string]: Swiper },
    init(): void,
    initSwiper($swiper: HTMLElement, name: string): void,
};

const SinglePostListCarousel: SinglePostListCarouselType = {
    $swipers: null,
    swipers: {},

    init() : void {
        this.$swipers = document.querySelectorAll<HTMLElement>('.post-list-carousel-swiper');

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index.toString());
        });
    },

    initSwiper($swiper: HTMLElement, name: string) : void {
        this.swipers[name] = new Swiper($swiper, {
            updateOnWindowResize: true,
            slidesPerView: 'auto',
            loop: false,
            allowTouchMove: true,
            threshold: 0,
            spaceBetween: 30,
            breakpoints: {
                [DeviceManager.devices.lg]: {
                    spaceBetween: 45,
                },
            },
        });
    },
};

export default SinglePostListCarousel;
